import {
    RESET_THE_STORE_TO_INITIAL_STATE,
    RETRIEVE_UNIT_TYPES,
  } from "../actions/types";
  
  const initialState = {
    unitTypes: [], 
  };
  
  function unitTypesReducer(state = initialState, action) {
    const { type, payload } = action;
  
    switch (type) {
      case RESET_THE_STORE_TO_INITIAL_STATE:
        return {
          ...initialState        }


      case RETRIEVE_UNIT_TYPES:
        if(!payload) return state; 
        return {
                ...state,
                unitTypes: payload,
        }


  
      default:
        return state;
    }
  };
  
  export default unitTypesReducer;